import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
// Cycle-4 LaTeX cutover (D5): KaTeX CSS imported once at the root so math
// glyphs render correctly wherever MarkdownText is mounted. Eager-loaded —
// no lazy chunk split for math (per design plan §2 WS-C, D5 LOCKED).
import 'katex/dist/katex.min.css'
import { installAppAuthFetchInterceptor } from './app/auth/fetchInterceptor'
import './i18n' // fr-locale Phase 3a: initialize i18next before any component renders

installAppAuthFetchInterceptor()

// WI-SSO-UI (ship-boundary hardening): force a full reload when the page is restored from the browser
// back/forward cache (bfcache). index.html is already served Cache-Control: no-store
// (staticwebapp.config.json), which excludes it from bfcache on modern Chrome/Firefox — but Safari and
// older browsers may still restore a FROZEN DOM without re-running AppAuthGate, re-exposing a prior (now
// signed-out) user's rendered admin view on a shared browser via Back. Reloading on `persisted` re-runs
// the gate from a clean state so a signed-out session can never be recovered from bfcache.
window.addEventListener('pageshow', (e) => {
  if ((e as PageTransitionEvent).persisted) {
    window.location.reload();
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
)
